import { render, staticRenderFns } from "./ShimmerDetailV2.vue?vue&type=template&id=04ff8852&scoped=true"
var script = {}
import style0 from "./ShimmerDetailV2.vue?vue&type=style&index=0&id=04ff8852&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ff8852",
  null
  
)

export default component.exports